<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="select col mr-2">
                <select v-model="area" :disabled="loading==true">
                  <option value="">Select Area</option>
                  <option value="savings">Saving Orders</option>
                  <option value="printing_papers">Digital Print</option>
                  <option value="printing_rolls">Transmatic</option>
                  <option value="cuttings">Gerber Cutting</option>
                  
                </select>
              </div>

              <div class="select col mr-2">
                <select v-model="user_id"  :disabled="loading==true">
                  <option value="">Select User</option>
                  <option  v-for="row in user_list" :key="row.user_id" :value="row.user_id">{{ row.firstname}} {{ row.surname }}</option>
                  
                </select>
              </div>
              <div class="select col mr-2">
                <select v-model="machine_id"  :disabled="loading==true">
                  <option value="">Select Machine</option>
                  <option  v-for="row in machine_list" :key="row.machine_id" :value="row.machine_id">{{ row.machine_name}}</option>
                  
                </select>
              </div>
            

             <div class=" col mr-2">
               <input type="date" class="input" v-model="start_date"  :disabled="loading==true"/>
                
              </div>
              <div class=" col mr-2" >
                <input type="date" class="input" v-model="end_date"  :disabled="loading==true"/>
                
              </div>

              <div class="col mr-2">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total {{ total_label }}</td>
                        <td>{{ total_qty }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
      <div class="notification is-info" v-if="loading == true">Loading data ...</div>

      <div class="tabs is-boxed" v-if="loading == false">
        <ul>
          <li :class="{ 'is-active': active_tab == 'all_actions' }">
            <a @click="active_tab = 'all_actions'">All Actions</a>
          </li>
          <li :class="{ 'is-active': active_tab == 'order_summary' }">
            <a @click="active_tab = 'order_summary'">Order Summary</a>
          </li>
        </ul>
      </div>


    <table class="table is-hoverable is-fullwidth" id="entriestable" v-if="loading == false && active_tab == 'all_actions' && filteredEntries.length > 0">
    	<thead>
    		<tr>
          <th>Date </th>
          <th v-if="area != 'savings'">Machine </th>
          <th>User </th>
        <th v-if="area != 'savings'">Qty</th>
        <th v-if="area != 'savings'">Size</th>
        <th>Order</th>
        <th v-if="area == 'savings'">Status</th>
       
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="row in filteredEntries" v-bind:key="row.id" >
          <td >{{ row.date }}</td>
          <td v-if="area != 'savings'">{{ row.machine_name }}</td>
          <td >{{ row.firstname }} {{ row.surname }}</td>
          <td v-if="area != 'savings'">{{row.qty}}</td>
          <td v-if="area != 'savings'">{{row.size_name}}</td>
          <td>{{row.ponumber}}</td>
          <td v-if="area == 'savings'">{{ showSaveStatus(row.status) }}</td>
              
			</tr>
    	</tbody>
    </table>

    <table class="table is-hoverable is-fullwidth" id="ordersummarytable" v-if="loading == false && active_tab == 'order_summary' && orderSummaryEntries.length > 0">
      <thead>
        <tr>
          <th>PO Number</th>
          <th>Total Qty</th>
          
          <!--<th v-if="1==2">First Date</th>
          <th v-if="1==2">Last Date</th>-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in orderSummaryEntries" :key="row.ponumber">
          <td>{{ row.ponumber }}</td>
          <td>{{ row.total_qty }}</td>
          <!--<td v-if="1==2">{{ row.first_date }}</td>
          <td v-if="1==2">{{ row.last_date }}</td>-->
        </tr>
      </tbody>
    </table>

    <div class="notification" v-if="loading == false && active_tab == 'order_summary' && orderSummaryEntries.length == 0">
      No order summary data found for the selected filters.
    </div>
    


  <button @click="exportXLS()" class="button is-info" v-if="loading==false && active_tab == 'all_actions'">Export to Excel</button>
  <button @click="exportXLSSummary()" class="button is-success" v-if="loading==false && active_tab == 'order_summary'">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  name:'PrintingCuttingSummary',
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
     entries: [],
     area: '',
      start_date: '',
        end_date: '',
      currentSort: 'count',
      currentSortDir: 'desc',
      loading: true,
     accessToken: '',
     user_id: '',
      machine_id: '',
      active_tab: 'all_actions'
     
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getData()
        });
      
    },
  methods: {
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('entriestable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Printing Cutting Summary Report.xlsx')

	 },
    exportXLSSummary() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('ordersummarytable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Printing Cutting Summary Report - Order Summary.xlsx')

	 },
   
    async getData() {
      if(this.accessToken == "")
      {
        this.loading=false;
        return
      }
      else {
        this.loading=true;
        OrderService.getPrintingCuttingReportData(this.accessToken, this.area, this.start_date, this.end_date)
            .then(
              (entries => {
                
                this.$set(this, "entries", entries);
                this.loading=false;
              }).bind(this)
            );
      }
      
    },
   
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },

        
   
  },
  computed : {
     
    
      total_qty: function() {
        if(this.area == 'savings')
        {
          return this.filteredEntries.length;
        }
        else{
          return this.filteredEntries.reduce((total, item) => total + item.qty, 0);
        }
        
      },
      
      total_label: function() {
          if(this.area == "savings")
          {
            return "Orders"
          }
          else{
            return "Garments"
          }
        },

        user_list: function() {
          let user_list = []
          let user_id_list = []
          
          this.entries.forEach(element => {
             
             if(!user_id_list.includes(element.user_id))
             {
              var this_user = {user_id: element.user_id, firstname: element.firstname, surname: element.surname}
              user_list.push(this_user)

              user_id_list.push(element.user_id)
             }
            
          })

          user_list.sort()

          return user_list
        },
        machine_list: function() {
          let machine_list = []
          let machine_id_list = []
          
          this.entries.forEach(element => {
             
             if(!machine_id_list.includes(element.machine_id))
             {
              var this_machine = {machine_id: element.machine_id, machine_name: element.machine_name}
              machine_list.push(this_machine)

              machine_id_list.push(element.machine_id)
             }
            
          })

          machine_list.sort((a, b) => {
            return a.machine_name.localeCompare(b.machine_name)
          })
          

          return machine_list
        },
        filteredEntries: function () {
          let filteredEntries = []

          if(this.user_id != "")
          {
            filteredEntries = this.entries.filter(row => row.user_id == this.user_id)

            if(this.machine_id != "")
            {
              filteredEntries = filteredEntries.filter(row => row.machine_id == this.machine_id)
            }
          }
          else{

            if(this.machine_id != "")
            {
              filteredEntries = this.entries.filter(row => row.machine_id == this.machine_id)
            }
            else{
              filteredEntries = this.entries
            }

            
          }

            return filteredEntries
        
      },

      orderSummaryEntries: function () {
        let grouped = {}

        this.filteredEntries.forEach(row => {
          if(!row.ponumber)
          {
            return
          }

          let qty = this.area == 'savings' ? 1 : Number(row.qty)
          if(Number.isNaN(qty))
          {
            qty = 0
          }

          if(!grouped[row.ponumber])
          {
            grouped[row.ponumber] = {
              ponumber: row.ponumber,
              total_qty: 0,
              first_date: row.date,
              last_date: row.date
            }
          }

          grouped[row.ponumber].total_qty += qty

          if(new Date(row.date) < new Date(grouped[row.ponumber].first_date))
          {
            grouped[row.ponumber].first_date = row.date
          }

          if(new Date(row.date) > new Date(grouped[row.ponumber].last_date))
          {
            grouped[row.ponumber].last_date = row.date
          }
        })

        return Object.values(grouped).sort((a, b) => {
          return new Date(b.last_date) - new Date(a.last_date)
        })
      }

  },

 
  mounted() {
    if (localStorage.printingcuttingsummary_start_date) {
      this.start_date = localStorage.printingcuttingsummary_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.printingcuttingsummary_end_date) {
      this.end_date = localStorage.printingcuttingsummary_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    if (localStorage.printingcuttingsummary_area) {
      this.area = localStorage.printingcuttingsummary_area;
    }
    else{
      this.area = 'printing_papers'
    }

    if (localStorage.printingcuttingsummary_user_id) {
      this.user_id = localStorage.printingcuttingsummary_user_id;
    }
    else{
      this.user_id = ''
    }

    if (localStorage.printingcuttingsummary_machine_id) {
      this.machine_id = localStorage.printingcuttingsummary_machine_id;
    }
    else{
      this.machine_id = ''
    }
    
  },
  watch: {
    area: function () {
      localStorage.printingcuttingsummary_area = this.area;
      this.entries = []
      this.getData()
    },
    start_date: function () {
      localStorage.printingcuttingsummary_start_date = this.start_date;
      this.entries = []
      this.getData()
    },
    end_date: function () {
      localStorage.printingcuttingsummary_end_date = this.end_date;
      this.entries = []
      this.getData()
    },
    user_id: function () {
      localStorage.printingcuttingsummary_user_id = this.user_id;
      
    },
    machine_id: function () {
      localStorage.printingcuttingsummary_machine_id = this.machine_id;
      
    },
  }
}



</script>


